var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.35718,
    y: 0.5,
    width: 16.1429,
    height: 14,
    rx: 1.5,
    stroke: "#171717"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17.0952,
    height: 14,
    rx: 1.5,
    fill: "white",
    stroke: "#171717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.381 3.78261V3H6.66675V3.78261H8.63103C9.02521 3.78388 9.40516 3.94417 9.69832 4.23289C9.99147 4.52161 10.1773 4.91852 10.2203 5.34783H6.66675V6.13043H10.2203C10.1773 6.55974 9.99147 6.95665 9.69832 7.24537C9.40516 7.53409 9.02521 7.69438 8.63103 7.69565H6.66675V8.61326L10.1014 12L10.5792 11.4185L7.59746 8.47826H8.63103C9.21535 8.47733 9.77789 8.23515 10.2065 7.80001C10.6351 7.36486 10.8983 6.76872 10.9435 6.13043H12.381V5.34783H10.9435C10.9026 4.76026 10.6758 4.20674 10.3025 3.78261H12.381Z",
    fill: "#171717"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.eafa0bbc.svg";
export { ForwardRef as ReactComponent };